// ToDo add game not found component
export default function GameNotFound() {
  return <h1>Game not found</h1>
}
